var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDotsHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5m0 11.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.033 15.833A.033.033 0 0 0 10 15.8a.033.033 0 0 0-.034.033c0 .019.015.033.034.034a.033.033 0 0 0 .033-.034m0-5.833a.033.033 0 1 0-.067 0c0 .018.016.033.034.034a.033.033 0 0 0 .033-.034m0-5.834A.033.033 0 0 0 10 4.133a.034.034 0 0 0-.034.033c0 .019.015.033.034.034a.033.033 0 0 0 .033-.034m1.6 11.667a1.634 1.634 0 1 1-3.268 0 1.634 1.634 0 0 1 3.268 0m0-5.833a1.634 1.634 0 1 1-3.266 0 1.634 1.634 0 0 1 3.268.001m0-5.834a1.634 1.634 0 1 1-3.268 0 1.634 1.634 0 0 1 3.268 0"
})));
SvgDotsHorizontal.displayName = "SvgDotsHorizontal";
export { SvgDotsHorizontal as ReactComponent };
export default SvgDotsHorizontal;